import type { ConnectorManifest, ImportTarget } from '../connectorRegistry';

export function isBuiltInConnectedTabularConnector(manifest: ConnectorManifest): boolean {
  return (
    manifest.source?.requiresIntentResolution === true &&
    (manifest.source.system === 'google_sheets' || manifest.source.system === 'excel')
  );
}

export function isBuiltInConnectedDirectoryConnector(manifest: ConnectorManifest): boolean {
  return (
    manifest.source?.system === 'azure_ad' ||
    manifest.source?.system === 'google_workspace' ||
    manifest.source?.system === 'bamboohr'
  );
}

export function isBuiltInConnectedSourceConnector(manifest: ConnectorManifest): boolean {
  return (
    isBuiltInConnectedTabularConnector(manifest) ||
    isBuiltInConnectedDirectoryConnector(manifest)
  );
}

export function isBuiltInImportSourceModalConnector(manifest: ConnectorManifest): boolean {
  return (
    manifest.status === 'coming-soon' ||
    manifest.format === 'file' ||
    isBuiltInConnectedSourceConnector(manifest)
  );
}

export function supportsBuiltInImportSourceTarget(
  manifest: ConnectorManifest,
  target: ImportTarget,
): boolean {
  if (target === 'folder') return true;
  return !isBuiltInImportSourceModalConnector(manifest);
}

export function filterConnectorsForBuiltInImportTarget(
  connectors: readonly ConnectorManifest[],
  target: ImportTarget,
): ConnectorManifest[] {
  return connectors.filter((connector) => supportsBuiltInImportSourceTarget(connector, target));
}
